// ConvoCX app shell — SEO document-meta hook (CON-853).
// Updates the browser tab title and the description meta on route change so
// every FR-12.5 app page carries a unique, meaningful title + description.

import { useEffect } from 'react';

const BRAND = 'ConvoCX';
const DEFAULT_TITLE = 'ConvoCX — Unified Messaging Inbox';

function upsertMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Set document.title + description + Open Graph tags for a route. */
export function usePageMeta(title: string, description?: string): void {
  useEffect(() => {
    document.title = title ? `${title} — ${BRAND}` : DEFAULT_TITLE;
    if (description) {
      upsertMeta('name', 'description', description);
      upsertMeta('property', 'og:description', description);
      upsertMeta('name', 'twitter:description', description);
    }
    if (title) {
      upsertMeta('property', 'og:title', `${title} — ${BRAND}`);
      upsertMeta('name', 'twitter:title', `${title} — ${BRAND}`);
    }
  }, [title, description]);
}